import { useConfig } from '@namespace/cms';
import { useThemeComponents } from '@namespace/themes';
import { EmailConfirmation } from '../../common/EmailConfirmation';

export const EmailVerificationSuccess = ({ id }) => {
  const { config } = useConfig(id);
  const { EmailVerificationSuccess: PartnerEmailVerificationSuccess } =
    useThemeComponents();

  if (PartnerEmailVerificationSuccess) {
    return <PartnerEmailVerificationSuccess />;
  }

  return <EmailConfirmation pageConfig={config} isSuccessPage={true} />;
};
